/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const datePickerStyles = {
  maxWidth: 150,
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "& .MuiOutlinedInput-root": {
    height: "38px",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};
